import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface ModalContentProps {
  horizontal?: boolean;
  backgroundColor?: string;
  children?: ReactNode;
}

export const ModalContent = styled.div<ModalContentProps>`
  max-height: calc(100vh - 20px);
  overflow: auto;
  padding: 15px 0 0;
  background-color: ${({ theme }) => theme.palette.backgrounds.tab};
  border: 1px solid ${({ theme }) => theme.palette.neutral.light};
  border-radius: 0;
  position: relative;

  ${({ horizontal }) =>
    horizontal &&
    css`
      display: flex;
      justify-content: flex-start;
      padding: 0;
    `}

  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background-color: ${backgroundColor};
    `}
`;
